module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "table-contents"
  }, [_c('h1', {
    attrs: {
      "id": "toc"
    }
  }, [_vm._v("Table of Contents")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "display": "table"
    }
  }, [_c('a', {
    staticClass: "table-row",
    attrs: {
      "href": "javascript:void(0);"
    },
    on: {
      "click": function($event) {
        _vm.goToByScroll('acknowledgements')
      }
    }
  }, [_c('span', {
    staticClass: "table-cell bold"
  }, [_vm._v("Acknowledgements and Contributions")])]), _vm._v(" "), _c('a', {
    staticClass: "table-row",
    attrs: {
      "href": "javascript:void(0);"
    },
    on: {
      "click": function($event) {
        _vm.goToByScroll('bc-provincial-stop')
      }
    }
  }, [_c('span', {
    staticClass: "table-cell bold"
  }, [_vm._v("BC Provincial STOP Program")])]), _vm._v(" "), _c('a', {
    staticClass: "table-row",
    attrs: {
      "href": "javascript:void(0);"
    },
    on: {
      "click": function($event) {
        _vm.goToByScroll('interpreting')
      }
    }
  }, [_c('span', {
    staticClass: "table-cell bold"
  }, [_vm._v("A Note on Monitoring and Interpreting HIV Indicators")])])]), _vm._v(" "), _c('div', [_c('a', {
    staticClass: "table-row",
    attrs: {
      "href": "javascript:void(0);"
    },
    on: {
      "click": function($event) {
        _vm.goToByScroll(1)
      }
    }
  }, [_c('span', {
    staticClass: "table-cell fixed-column bold"
  }, [_vm._v("Indicator 1")]), _vm._v(" "), _vm._m(0)]), _vm._v(" "), _c('a', {
    staticClass: "table-row",
    attrs: {
      "href": "javascript:void(0);"
    },
    on: {
      "click": function($event) {
        _vm.goToByScroll('1-1')
      }
    }
  }, [_c('span', {
    staticClass: "table-cell fixed-column"
  }, [_vm._v("Figure 1.1")]), _vm._v(" "), _c('span', {
    staticClass: "table-cell"
  }, [_vm._v("HIV Test Episodes for " + _vm._s(this.$parent.haName) + ", " + _vm._s(this.$parent.period))])]), _vm._v(" "), _c('a', {
    staticClass: "table-row",
    attrs: {
      "href": "javascript:void(0);"
    },
    on: {
      "click": function($event) {
        _vm.goToByScroll('1-2')
      }
    }
  }, [_c('span', {
    staticClass: "table-cell fixed-column"
  }, [_vm._v("Figure 1.2")]), _vm._v(" "), _c('span', {
    staticClass: "table-cell"
  }, [_vm._v("HIV Test Episodes for " + _vm._s(this.$parent.haName) + " by Gender, " + _vm._s(this.$parent.period))])]), _vm._v(" "), _c('a', {
    staticClass: "table-row",
    attrs: {
      "href": "javascript:void(0);"
    },
    on: {
      "click": function($event) {
        _vm.goToByScroll('1-3')
      }
    }
  }, [_c('span', {
    staticClass: "table-cell fixed-column"
  }, [_vm._v("Figure 1.3")]), _vm._v(" "), _c('span', {
    staticClass: "table-cell"
  }, [_vm._v("HIV Test Episodes for " + _vm._s(this.$parent.haName) + " by Age Category, " + _vm._s(this.$parent.period))])]), _vm._v(" "), _c('a', {
    staticClass: "table-row",
    attrs: {
      "href": "javascript:void(0);"
    },
    on: {
      "click": function($event) {
        _vm.goToByScroll('1-4')
      }
    }
  }, [_c('span', {
    staticClass: "table-cell fixed-column"
  }, [_vm._v("Figure 1.4")]), _vm._v(" "), _c('span', {
    staticClass: "table-cell"
  }, [_vm._v("Point-of-Care HIV Tests for " + _vm._s(this.$parent.haName) + ", " + _vm._s(this.$parent.period))])]), _vm._v(" "), _c('a', {
    staticClass: "table-row",
    attrs: {
      "href": "javascript:void(0);"
    },
    on: {
      "click": function($event) {
        _vm.goToByScroll('1-5')
      }
    }
  }, [_c('span', {
    staticClass: "table-cell fixed-column"
  }, [_vm._v("Figure 1.5")]), _vm._v(" "), _c('span', {
    staticClass: "table-cell"
  }, [_vm._v("HIV Test Episodes by " + _vm._s(this.$parent.groupBy) + " for " + _vm._s(this.$parent.haName) + ", " + _vm._s(this.$parent.period))])]), _vm._v(" "), _c('a', {
    staticClass: "table-row",
    attrs: {
      "href": "javascript:void(0);"
    },
    on: {
      "click": function($event) {
        _vm.goToByScroll('1-6')
      }
    }
  }, [_c('span', {
    staticClass: "table-cell fixed-column"
  }, [_vm._v("Figure 1.6")]), _vm._v(" "), _c('span', {
    staticClass: "table-cell"
  }, [_vm._v("HIV Test Episodes for Non-Prenatal Females in " + _vm._s(this.$parent.haName) + " by " + _vm._s(this.$parent.groupBy) + ", " + _vm._s(this.$parent.period))])]), _vm._v(" "), _c('a', {
    staticClass: "table-row",
    attrs: {
      "href": "javascript:void(0);"
    },
    on: {
      "click": function($event) {
        _vm.goToByScroll('1-7')
      }
    }
  }, [_c('span', {
    staticClass: "table-cell fixed-column"
  }, [_vm._v("Figure 1.7")]), _vm._v(" "), _c('span', {
    staticClass: "table-cell"
  }, [_vm._v("HIV Test Episodes for Males in " + _vm._s(this.$parent.haName) + " by " + _vm._s(this.$parent.groupBy) + ", " + _vm._s(this.$parent.period))])]), _vm._v(" "), _c('a', {
    staticClass: "table-row",
    attrs: {
      "href": "javascript:void(0);"
    },
    on: {
      "click": function($event) {
        _vm.goToByScroll('2')
      }
    }
  }, [_c('span', {
    staticClass: "table-cell fixed-column bold"
  }, [_vm._v("Indicator 2")]), _vm._v(" "), _vm._m(1)]), _vm._v(" "), _c('a', {
    staticClass: "table-row",
    attrs: {
      "href": "javascript:void(0);"
    },
    on: {
      "click": function($event) {
        _vm.goToByScroll('2-1')
      }
    }
  }, [_c('span', {
    staticClass: "table-cell fixed-column"
  }, [_vm._v("Figure 2.1")]), _vm._v(" "), _c('span', {
    staticClass: "table-cell"
  }, [_vm._v("Rate of HIV Testing for " + _vm._s(this.$parent.haName) + " and " + _vm._s(this.$parent.groupByPlural) + ", 2009–2017")])]), _vm._v(" "), _c('a', {
    staticClass: "table-row",
    attrs: {
      "href": "javascript:void(0);"
    },
    on: {
      "click": function($event) {
        _vm.goToByScroll('2-2')
      }
    }
  }, [_c('span', {
    staticClass: "table-cell fixed-column"
  }, [_vm._v("Figure 2.2")]), _vm._v(" "), _c('span', {
    staticClass: "table-cell"
  }, [_vm._v("Rate of HIV Testing for " + _vm._s(this.$parent.haName) + " by Gender, 2009–2017")])]), _vm._v(" "), _c('a', {
    staticClass: "table-row",
    attrs: {
      "href": "javascript:void(0);"
    },
    on: {
      "click": function($event) {
        _vm.goToByScroll('2-3')
      }
    }
  }, [_c('span', {
    staticClass: "table-cell fixed-column"
  }, [_vm._v("Figure 2.3")]), _vm._v(" "), _c('span', {
    staticClass: "table-cell"
  }, [_vm._v("Rate of HIV Testing for " + _vm._s(this.$parent.haName) + " by Age Category, 2009–2017")])]), _vm._v(" "), _c('a', {
    staticClass: "table-row",
    attrs: {
      "href": "javascript:void(0);"
    },
    on: {
      "click": function($event) {
        _vm.goToByScroll('3')
      }
    }
  }, [_c('span', {
    staticClass: "table-cell fixed-column bold"
  }, [_vm._v("Indicator 3")]), _vm._v(" "), _c('span', {
    staticClass: "table-cell bold"
  }, [_vm._v("New HIV Diagnoses")])]), _vm._v(" "), _c('a', {
    staticClass: "table-row",
    attrs: {
      "href": "javascript:void(0);"
    },
    on: {
      "click": function($event) {
        _vm.goToByScroll('3-1')
      }
    }
  }, [_c('span', {
    staticClass: "table-cell fixed-column"
  }, [_vm._v("Figure 3.1")]), _vm._v(" "), _c('span', {
    staticClass: "table-cell"
  }, [_vm._v("New HIV Diagnoses for " + _vm._s(this.$parent.haName) + ", " + _vm._s(this.$parent.period))])]), _vm._v(" "), _c('a', {
    staticClass: "table-row",
    attrs: {
      "href": "javascript:void(0);"
    },
    on: {
      "click": function($event) {
        _vm.goToByScroll('3-2')
      }
    }
  }, [_c('span', {
    staticClass: "table-cell fixed-column"
  }, [_vm._v("Figure 3.2")]), _vm._v(" "), _c('span', {
    staticClass: "table-cell"
  }, [_vm._v("New HIV Diagnoses for " + _vm._s(this.$parent.haName) + " by Gender, " + _vm._s(this.$parent.period))])]), _vm._v(" "), _c('a', {
    staticClass: "table-row",
    attrs: {
      "href": "javascript:void(0);"
    },
    on: {
      "click": function($event) {
        _vm.goToByScroll('3-3')
      }
    }
  }, [_c('span', {
    staticClass: "table-cell fixed-column"
  }, [_vm._v("Figure 3.3")]), _vm._v(" "), _c('span', {
    staticClass: "table-cell"
  }, [_vm._v("New HIV Diagnoses for " + _vm._s(this.$parent.haName) + " by Age Category, " + _vm._s(this.$parent.period))])]), _vm._v(" "), _c('a', {
    staticClass: "table-row",
    attrs: {
      "href": "javascript:void(0);"
    },
    on: {
      "click": function($event) {
        _vm.goToByScroll('3-4')
      }
    }
  }, [_c('span', {
    staticClass: "table-cell fixed-column"
  }, [_vm._v("Figure 3.4")]), _vm._v(" "), _c('span', {
    staticClass: "table-cell"
  }, [_vm._v("New HIV Diagnoses for " + _vm._s(this.$parent.haName) + " by Exposure Category, 2012 Q4-2017-Q3")])]), _vm._v(" "), _c('a', {
    staticClass: "table-row",
    attrs: {
      "href": "javascript:void(0);"
    },
    on: {
      "click": function($event) {
        _vm.goToByScroll('3-5')
      }
    }
  }, [_c('span', {
    staticClass: "table-cell fixed-column"
  }, [_vm._v("Figure 3.5")]), _vm._v(" "), _c('span', {
    staticClass: "table-cell"
  }, [_vm._v("New HIV Diagnoses for " + _vm._s(this.$parent.haName) + " by " + _vm._s(this.$parent.groupBy) + ", " + _vm._s(this.$parent.period))])]), _vm._v(" "), _c('a', {
    staticClass: "table-row",
    attrs: {
      "href": "javascript:void(0);"
    },
    on: {
      "click": function($event) {
        _vm.goToByScroll('4')
      }
    }
  }, [_c('span', {
    staticClass: "table-cell fixed-column bold"
  }, [_vm._v("Indicator 4")]), _vm._v(" "), _vm._m(2)]), _vm._v(" "), _c('a', {
    staticClass: "table-row",
    attrs: {
      "href": "javascript:void(0);"
    },
    on: {
      "click": function($event) {
        _vm.goToByScroll('table1')
      }
    }
  }, [_c('span', {
    staticClass: "table-cell fixed-column"
  }, [_vm._v("Table 1")]), _vm._v(" "), _c('span', {
    staticClass: "table-cell"
  }, [_vm._v("Staging Classifications of Infection at Time of HIV Diagnosis Based on CDC HIV Surveillance Case Definitions")])]), _vm._v(" "), _c('a', {
    staticClass: "table-row",
    attrs: {
      "href": "javascript:void(0);"
    },
    on: {
      "click": function($event) {
        _vm.goToByScroll('4-1')
      }
    }
  }, [_c('span', {
    staticClass: "table-cell fixed-column"
  }, [_vm._v("Figure 4.1")]), _vm._v(" "), _c('span', {
    staticClass: "table-cell"
  }, [_vm._v("Stage of HIV Infection at Diagnosis for " + _vm._s(this.$parent.haName) + ", 2013–2017")])]), _vm._v(" "), _c('a', {
    staticClass: "table-row",
    attrs: {
      "href": "javascript:void(0);"
    },
    on: {
      "click": function($event) {
        _vm.goToByScroll('4-2')
      }
    }
  }, [_c('span', {
    staticClass: "table-cell fixed-column"
  }, [_vm._v("Figure 4.2")]), _vm._v(" "), _c('span', {
    staticClass: "table-cell"
  }, [_vm._v("Stage of HIV Infection at Diagnosis for " + _vm._s(this.$parent.haName) + " by Gender, 2013–2017")])]), _vm._v(" "), _c('a', {
    staticClass: "table-row",
    attrs: {
      "href": "javascript:void(0);"
    },
    on: {
      "click": function($event) {
        _vm.goToByScroll('4-3')
      }
    }
  }, [_c('span', {
    staticClass: "table-cell fixed-column"
  }, [_vm._v("Figure 4.3")]), _vm._v(" "), _c('span', {
    staticClass: "table-cell"
  }, [_vm._v("Stage of HIV Infection at Diagnosis for " + _vm._s(this.$parent.haName) + " by Age Category, 2013–2017")])]), _vm._v(" "), _c('a', {
    staticClass: "table-row",
    attrs: {
      "href": "javascript:void(0);"
    },
    on: {
      "click": function($event) {
        _vm.goToByScroll('4-4')
      }
    }
  }, [_c('span', {
    staticClass: "table-cell fixed-column"
  }, [_vm._v("Figure 4.4")]), _vm._v(" "), _c('span', {
    staticClass: "table-cell"
  }, [_vm._v("Stage of HIV Infection at Diagnosis for " + _vm._s(this.$parent.haName) + " by Exposure Category, 2012–2016")])]), _vm._v(" "), _c('a', {
    staticClass: "table-row",
    attrs: {
      "href": "javascript:void(0);"
    },
    on: {
      "click": function($event) {
        _vm.goToByScroll('5')
      }
    }
  }, [_c('span', {
    staticClass: "table-cell fixed-column bold"
  }, [_vm._v("Indicator 5")]), _vm._v(" "), _c('span', {
    staticClass: "table-cell bold"
  }, [_vm._v("HIV Cascade of Care")])]), _vm._v(" "), _c('a', {
    staticClass: "table-row",
    attrs: {
      "href": "javascript:void(0);"
    },
    on: {
      "click": function($event) {
        _vm.goToByScroll('5-1')
      }
    }
  }, [_c('span', {
    staticClass: "table-cell fixed-column"
  }, [_vm._v("Figure 5.1")]), _vm._v(" "), _c('span', {
    staticClass: "table-cell"
  }, [_vm._v("Estimated Cascade of Care for " + _vm._s(this.$parent.haName) + ", Year Ending " + _vm._s(this.$parent.lastYear) + " Q" + _vm._s(this.$parent.lastQuarter))])]), _vm._v(" "), _c('a', {
    staticClass: "table-row",
    attrs: {
      "href": "javascript:void(0);"
    },
    on: {
      "click": function($event) {
        _vm.goToByScroll('5-2')
      }
    }
  }, [_c('span', {
    staticClass: "table-cell fixed-column"
  }, [_vm._v("Figure 5.2")]), _vm._v(" "), _c('span', {
    staticClass: "table-cell"
  }, [_vm._v("Estimated Cascade of Care for " + _vm._s(this.$parent.haName) + " by Gender, Year Ending " + _vm._s(this.$parent.lastYear) + " Q" + _vm._s(this.$parent.lastQuarter))])]), _vm._v(" "), _c('a', {
    staticClass: "table-row",
    attrs: {
      "href": "javascript:void(0);"
    },
    on: {
      "click": function($event) {
        _vm.goToByScroll('5-3')
      }
    }
  }, [_c('span', {
    staticClass: "table-cell fixed-column"
  }, [_vm._v("Figure 5.3")]), _vm._v(" "), _c('span', {
    staticClass: "table-cell"
  }, [_vm._v("Estimated Cascade of Care for " + _vm._s(this.$parent.haName) + " by Age Category, Year Ending " + _vm._s(this.$parent.lastYear) + " Q" + _vm._s(this.$parent.lastQuarter))])]), _vm._v(" "), _c('a', {
    staticClass: "table-row",
    attrs: {
      "href": "javascript:void(0);"
    },
    on: {
      "click": function($event) {
        _vm.goToByScroll('5-4')
      }
    }
  }, [_c('span', {
    staticClass: "table-cell fixed-column"
  }, [_vm._v("Figure 5.4")]), _vm._v(" "), _c('span', {
    staticClass: "table-cell"
  }, [_vm._v("Estimated Cascade of Care for " + _vm._s(this.$parent.haName) + " by MSM Status, Year Ending " + _vm._s(this.$parent.lastYear) + " Q" + _vm._s(this.$parent.lastQuarter))])]), _vm._v(" "), _c('a', {
    staticClass: "table-row",
    attrs: {
      "href": "javascript:void(0);"
    },
    on: {
      "click": function($event) {
        _vm.goToByScroll('5-5')
      }
    }
  }, [_c('span', {
    staticClass: "table-cell fixed-column"
  }, [_vm._v("Figure 5.5")]), _vm._v(" "), _c('span', {
    staticClass: "table-cell"
  }, [_vm._v("Estimated Cascade of Care for " + _vm._s(this.$parent.haName) + " by Age Category and MSM Status, Year Ending " + _vm._s(this.$parent.lastYear) + " Q" + _vm._s(this.$parent.lastQuarter))])]), _vm._v(" "), _c('a', {
    staticClass: "table-row",
    attrs: {
      "href": "javascript:void(0);"
    },
    on: {
      "click": function($event) {
        _vm.goToByScroll('5-6')
      }
    }
  }, [_c('span', {
    staticClass: "table-cell fixed-column"
  }, [_vm._v("Figure 5.6")]), _vm._v(" "), _c('span', {
    staticClass: "table-cell"
  }, [_vm._v("Estimated Cascade of Care for " + _vm._s(this.$parent.haName) + " by PWID Status, Year Ending " + _vm._s(this.$parent.lastYear) + " Q" + _vm._s(this.$parent.lastQuarter))])]), _vm._v(" "), _c('a', {
    staticClass: "table-row",
    attrs: {
      "href": "javascript:void(0);"
    },
    on: {
      "click": function($event) {
        _vm.goToByScroll('5-7')
      }
    }
  }, [_c('span', {
    staticClass: "table-cell fixed-column"
  }, [_vm._v("Figure 5.7")]), _vm._v(" "), _c('span', {
    staticClass: "table-cell"
  }, [_vm._v("Estimated Cascade of Care for " + _vm._s(this.$parent.haName) + " by " + _vm._s(this.$parent.groupBy) + ", Year Ending " + _vm._s(this.$parent.lastYear) + " Q" + _vm._s(this.$parent.lastQuarter))])]), _vm._v(" "), _c('a', {
    staticClass: "table-row",
    attrs: {
      "href": "javascript:void(0);"
    },
    on: {
      "click": function($event) {
        _vm.goToByScroll('6')
      }
    }
  }, [_c('span', {
    staticClass: "table-cell fixed-column bold"
  }, [_vm._v("Indicator 6")]), _vm._v(" "), _c('span', {
    staticClass: "table-cell bold"
  }, [_vm._v("Programmatic Compliance Score (PCS)")])]), _vm._v(" "), _c('a', {
    staticClass: "table-row",
    attrs: {
      "href": "javascript:void(0);"
    },
    on: {
      "click": function($event) {
        _vm.goToByScroll('table2')
      }
    }
  }, [_c('span', {
    staticClass: "table-cell fixed-column"
  }, [_vm._v("Table 2")]), _vm._v(" "), _c('span', {
    staticClass: "table-cell"
  }, [_vm._v("Probability of Mortality, Immunologic Failure and Virologic Failure Based on the Programmatic Compliance Score")])]), _vm._v(" "), _c('a', {
    staticClass: "table-row",
    attrs: {
      "href": "javascript:void(0);"
    },
    on: {
      "click": function($event) {
        _vm.goToByScroll('6-1')
      }
    }
  }, [_c('span', {
    staticClass: "table-cell fixed-column"
  }, [_vm._v("Figure 6.1")]), _vm._v(" "), _c('span', {
    staticClass: "table-cell"
  }, [_c('div', {
    staticStyle: {
      "padding-bottom": "12px"
    }
  }, [_vm._v("PCS Components for " + _vm._s(this.$parent.haName) + ", 2016 Q2–" + _vm._s(this.$parent.lastYear) + " Q" + _vm._s(this.$parent.lastQuarter))]), _vm._v(" "), _c('div', {
    staticStyle: {
      "padding-left": "30px",
      "padding-bottom": "12px"
    }
  }, [_vm._v("Less than 3 CD4 Tests in First Year")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "padding-left": "30px",
      "padding-bottom": "12px"
    }
  }, [_vm._v("Less than 3 Viral Load Tests in First Year")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "padding-left": "30px",
      "padding-bottom": "12px"
    }
  }, [_vm._v("Not Having Drug Resistance Testing at Baseline")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "padding-left": "30px",
      "padding-bottom": "12px"
    }
  }, [_vm._v("Non-Recommended Antiretroviral Therapy Regimen (ART)")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "padding-left": "30px",
      "padding-bottom": "12px"
    }
  }, [_vm._v("Baseline CD4 < 200 cells/µL")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "padding-left": "30px"
    }
  }, [_vm._v("Not Achieving Viral Suppression at 9 Months")])])]), _vm._v(" "), _c('a', {
    staticClass: "table-row",
    attrs: {
      "href": "javascript:void(0);"
    },
    on: {
      "click": function($event) {
        _vm.goToByScroll('6-2')
      }
    }
  }, [_c('span', {
    staticClass: "table-cell fixed-column"
  }, [_vm._v("Figure 6.2")]), _vm._v(" "), _c('span', {
    staticClass: "table-cell"
  }, [_vm._v("Historical Trends for PCS Score for " + _vm._s(this.$parent.haName) + ", 2016 Q2–" + _vm._s(this.$parent.lastYear) + " Q" + _vm._s(this.$parent.lastQuarter))])]), _vm._v(" "), _c('a', {
    staticClass: "table-row",
    attrs: {
      "href": "javascript:void(0);"
    },
    on: {
      "click": function($event) {
        _vm.goToByScroll('7a')
      }
    }
  }, [_c('span', {
    staticClass: "table-cell fixed-column bold"
  }, [_vm._v("Indicator 7")]), _vm._v(" "), _c('span', {
    staticClass: "table-cell bold"
  }, [_vm._v("New Antiretroviral Therapy Starts in " + _vm._s(this.$parent.haName))])]), _vm._v(" "), _c('a', {
    staticClass: "table-row",
    attrs: {
      "href": "javascript:void(0);"
    },
    on: {
      "click": function($event) {
        _vm.goToByScroll('7')
      }
    }
  }, [_c('span', {
    staticClass: "table-cell fixed-column"
  }, [_vm._v("Figure 7")]), _vm._v(" "), _c('span', {
    staticClass: "table-cell"
  }, [_vm._v("\n        BC-CfE Drug Treatment Program Enrollment:"), _c('br'), _vm._v(" "), _c('span', [_vm._v("New Antiretroviral Participants for " + _vm._s(this.$parent.haName) + ", 2016 Q2–" + _vm._s(this.$parent.lastYear) + " Q" + _vm._s(this.$parent.lastQuarter))])])]), _vm._v(" "), _c('a', {
    staticClass: "table-row",
    attrs: {
      "href": "javascript:void(0);"
    },
    on: {
      "click": function($event) {
        _vm.goToByScroll('8a')
      }
    }
  }, [_c('span', {
    staticClass: "table-cell fixed-column bold"
  }, [_vm._v("Indicator 8")]), _vm._v(" "), _c('span', {
    staticClass: "table-cell bold"
  }, [_vm._v("CD4 Cell Count at ART Initiation")])]), _vm._v(" "), _c('a', {
    staticClass: "table-row",
    attrs: {
      "href": "javascript:void(0);"
    },
    on: {
      "click": function($event) {
        _vm.goToByScroll('8')
      }
    }
  }, [_c('span', {
    staticClass: "table-cell fixed-column"
  }, [_vm._v("Figure 8")]), _vm._v(" "), _c('span', {
    staticClass: "table-cell"
  }, [_vm._v("CD4 Cell Count at ART Initiation for " + _vm._s(this.$parent.haName) + ", 2016 Q2–" + _vm._s(this.$parent.lastYear) + " Q" + _vm._s(this.$parent.lastQuarter))])]), _vm._v(" "), _c('a', {
    staticClass: "table-row",
    attrs: {
      "href": "javascript:void(0);"
    },
    on: {
      "click": function($event) {
        _vm.goToByScroll('9a')
      }
    }
  }, [_c('span', {
    staticClass: "table-cell fixed-column bold"
  }, [_vm._v("Indicator 9")]), _vm._v(" "), _c('span', {
    staticClass: "table-cell bold"
  }, [_vm._v("Active and Inactive Drug Treatment Program (DTP) Participants")])]), _vm._v(" "), _c('a', {
    staticClass: "table-row",
    attrs: {
      "href": "javascript:void(0);"
    },
    on: {
      "click": function($event) {
        _vm.goToByScroll('table3')
      }
    }
  }, [_c('span', {
    staticClass: "table-cell fixed-column"
  }, [_vm._v("Table 3")]), _vm._v(" "), _c('span', {
    staticClass: "table-cell"
  }, [_vm._v("Distribution of People on ART in " + _vm._s(this.$parent.haName) + ", " + _vm._s(this.$parent.lastYear) + " Q" + _vm._s(this.$parent.lastQuarter))])]), _vm._v(" "), _c('a', {
    staticClass: "table-row",
    attrs: {
      "href": "javascript:void(0);"
    },
    on: {
      "click": function($event) {
        _vm.goToByScroll('9')
      }
    }
  }, [_c('span', {
    staticClass: "table-cell fixed-column"
  }, [_vm._v("Figure 9")]), _vm._v(" "), _c('span', {
    staticClass: "table-cell"
  }, [_vm._v("Active and Inactive DTP Participants for " + _vm._s(this.$parent.haName) + ", 2016 Q2–" + _vm._s(this.$parent.lastYear) + " Q" + _vm._s(this.$parent.lastQuarter))])]), _vm._v(" "), _c('a', {
    staticClass: "table-row",
    attrs: {
      "href": "javascript:void(0);"
    },
    on: {
      "click": function($event) {
        _vm.goToByScroll('10a')
      }
    }
  }, [_c('span', {
    staticClass: "table-cell fixed-column bold"
  }, [_vm._v("Indicator 10")]), _vm._v(" "), _c('span', {
    staticClass: "table-cell bold"
  }, [_vm._v("Antiretroviral Adherence")])]), _vm._v(" "), _c('a', {
    staticClass: "table-row",
    attrs: {
      "href": "javascript:void(0);"
    },
    on: {
      "click": function($event) {
        _vm.goToByScroll('10')
      }
    }
  }, [_c('span', {
    staticClass: "table-cell fixed-column"
  }, [_vm._v("Figure 10")]), _vm._v(" "), _c('span', {
    staticClass: "table-cell"
  }, [_vm._v("\n        Distribution of Individuals by Adherence Level in 1st Year of Therapy,"), _c('br'), _vm._v(" "), _c('span', [_vm._v("Based on Pharmacy Refill Compliance for " + _vm._s(this.$parent.haName) + ", 2016 Q2–" + _vm._s(this.$parent.lastYear) + " Q" + _vm._s(this.$parent.lastQuarter))])])]), _vm._v(" "), _c('a', {
    staticClass: "table-row",
    attrs: {
      "href": "javascript:void(0);"
    },
    on: {
      "click": function($event) {
        _vm.goToByScroll('11a')
      }
    }
  }, [_c('span', {
    staticClass: "table-cell fixed-column bold"
  }, [_vm._v("Indicator 11")]), _vm._v(" "), _c('span', {
    staticClass: "table-cell bold"
  }, [_vm._v("Resistance Testing and Results")])]), _vm._v(" "), _c('a', {
    staticClass: "table-row",
    attrs: {
      "href": "javascript:void(0);"
    },
    on: {
      "click": function($event) {
        _vm.goToByScroll('11')
      }
    }
  }, [_c('span', {
    staticClass: "table-cell fixed-column"
  }, [_vm._v("Figure 11")]), _vm._v(" "), _c('span', {
    staticClass: "table-cell"
  }, [_vm._v("Cumulative Resistance Testing Results by Resistance Category for " + _vm._s(this.$parent.haName) + ", 2016 Q2–" + _vm._s(this.$parent.lastYear) + " Q" + _vm._s(this.$parent.lastQuarter))])]), _vm._v(" "), _c('a', {
    staticClass: "table-row",
    attrs: {
      "href": "javascript:void(0);"
    },
    on: {
      "click": function($event) {
        _vm.goToByScroll('12a')
      }
    }
  }, [_c('span', {
    staticClass: "table-cell fixed-column bold"
  }, [_vm._v("Indicator 12")]), _vm._v(" "), _c('span', {
    staticClass: "table-cell bold"
  }, [_vm._v("AIDS-Defining Illness")])]), _vm._v(" "), _c('a', {
    staticClass: "table-row",
    attrs: {
      "href": "javascript:void(0);"
    },
    on: {
      "click": function($event) {
        _vm.goToByScroll('12')
      }
    }
  }, [_c('span', {
    staticClass: "table-cell fixed-column"
  }, [_vm._v("Figure 12")]), _vm._v(" "), _c('span', {
    staticClass: "table-cell"
  }, [_vm._v("AIDS Case Rate and Reports for " + _vm._s(this.$parent.haName) + ", 2010–2016")])]), _vm._v(" "), _c('a', {
    staticClass: "table-row",
    attrs: {
      "href": "javascript:void(0);"
    },
    on: {
      "click": function($event) {
        _vm.goToByScroll('13a')
      }
    }
  }, [_c('span', {
    staticClass: "table-cell fixed-column bold"
  }, [_vm._v("Indicator 13")]), _vm._v(" "), _c('span', {
    staticClass: "table-cell bold"
  }, [_vm._v("HIV-Related Mortality")])]), _vm._v(" "), _c('a', {
    staticClass: "table-row",
    attrs: {
      "href": "javascript:void(0);"
    },
    on: {
      "click": function($event) {
        _vm.goToByScroll('13')
      }
    }
  }, [_c('span', {
    staticClass: "table-cell fixed-column"
  }, [_vm._v("Figure 13")]), _vm._v(" "), _c('span', {
    staticClass: "table-cell"
  }, [_vm._v("HIV-Related Deaths by Year for " + _vm._s(this.$parent.haName) + ": This indicator is currently under revision")])]), _vm._v(" "), _c('a', {
    staticClass: "table-row",
    attrs: {
      "href": "javascript:void(0);"
    },
    on: {
      "click": function($event) {
        _vm.goToByScroll('appendices')
      }
    }
  }, [_vm._m(3), _vm._v(" "), _c('span', {
    staticClass: "table-cell"
  })])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "table-cell"
  }, [_c('b', [_vm._v("HIV Testing Episodes")]), _vm._v(" "), _c('i', [_vm._v("All HIV Testing Episodes reflect non-prenatal tests. All prenatal tests have been removed.")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "table-cell"
  }, [_c('b', [_vm._v("HIV Testing Rates")]), _vm._v(" "), _c('i', [_vm._v("All HIV Testing Rates reflect non-prenatal tests. All prenatal tests have been removed")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "table-cell"
  }, [_c('b', [_vm._v("Stage of HIV Infection at Diagnosis")]), _vm._v(" "), _c('i', [_vm._v("Stage definitions have been altered to remove\n        AIDS diagnosis data. Individuals previously classified as Stage 3 have been re-classified based on CD4 cell count.")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "table-cell fixed-column bold"
  }, [_c('span', [_vm._v("Appendices")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7d609efc"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/web/components/TableContents.vue
// module id = 135
// module chunks = 0